/**
 * TEN VA BIEU TUONG CUA DOI TUONG, dung chung cho bang doi tuong va thanh
 * thuoc tinh.
 *
 * Mot ban duy nhat: neu bang goi mot dau la "Hộp chữ" con thanh thuoc tinh goi
 * no la "Chữ tự do" thi nguoi dung se tuong do la hai thu khac nhau.
 *
 * Nam trong tep .ts chu khong trong thanh phan React vi bo chay test nap duoc
 * .ts nhung khong nap duoc .tsx.
 */
import type { Annotation } from '@pdfeditor/types';

export const KIND_LABEL: Partial<Record<Annotation['kind'], string>> = {
  'text-note': 'Ghi chú',
  'free-text': 'Hộp chữ',
  square: 'Hình chữ nhật',
  circle: 'Hình bầu dục',
  line: 'Đường thẳng',
  arrow: 'Mũi tên',
  ink: 'Nét vẽ tay',
  stamp: 'Ảnh',
  highlight: 'Tô sáng',
  underline: 'Gạch chân',
  strikeout: 'Gạch ngang',
  squiggly: 'Gạch lượn sóng',
};

/** Bieu tuong mot ky tu cho tung loai. Khong dung emoji - quy uoc giao dien. */
export const KIND_ICON: Partial<Record<Annotation['kind'], string>> = {
  'text-note': '❏',
  'free-text': '⊞',
  square: '▭',
  circle: '◯',
  line: '╱',
  arrow: '↗',
  ink: '✎',
  stamp: '▣',
  highlight: '▤',
  underline: '＿',
  strikeout: '―',
  squiggly: '〜',
};

/**
 * Nhan doc duoc cua mot doi tuong: loai, cong mot trich noi dung neu co.
 *
 * VI SAO KHONG CO DOI TEN: mot cai ten do nguoi dung dat se can mot truong moi
 * trong hop dong kieu, phai di qua tuan tu hoa va cong tac, roi khong duoc ghi
 * vao dau ca trong tep PDF - khong co khoa nao cho "ten do nguoi dung dat". Mot
 * cai ten chi song trong phien lam viec roi bien mat khi luu la mot loi hua bi
 * be gay.
 */
export function objectLabel(annotation: Annotation): string {
  const kind = KIND_LABEL[annotation.kind] ?? annotation.kind;
  const text = (annotation.contents ?? '').replace(/\s+/g, ' ').trim();
  if (text.length === 0) return kind;
  const short = text.length <= 24 ? text : `${text.slice(0, 23)}…`;
  return `${kind}: ${short}`;
}
